
const $viewport = document.querySelector('meta[name=viewport]');
const VIEWPORT_DEFAULT_VALUE = $viewport.getAttribute('content');
const VIEWPORT_FIXED_VALUE = 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1';
const $root = document.documentElement;

export function disableScrolling() {
    $root.classList.add('has-disable-scrolling');
    $viewport.setAttribute('content', VIEWPORT_FIXED_VALUE);
}

export function enableScrolling() {
    $root.classList.remove('has-disable-scrolling');
    $viewport.setAttribute('content', VIEWPORT_DEFAULT_VALUE);
}